<template>
  <div style="background-color: #0076ec">
    <div class="container vertical-center">
      <div id="vueComponentLogin" class="col-sm-6 offset-sm-3">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="text-center border border-light p-5 form-login-lamsac"
          @submit="checkForm"
        >
          <img src="@/assets/images/logo.svg" class="logo-lamsac p-3" />

          <div class="w-full">
            <el-form-item
              class=""
              label="Correo Electrónico para responder su consulta"
              prop="email"
            >
              <el-input v-model="ruleForm.email"></el-input>
            </el-form-item>
          </div>
          <div class="w-full">
            <el-form-item class="" label="Mensaje" prop="mensaje">
              <el-input type="textarea" v-model="ruleForm.mensaje"></el-input>
            </el-form-item>
          </div>

          <!-- <div class="md-form">
          <textarea id="defaultRegisterFormPassword" type="text"
              name='password'
              class="form-control"
              aria-describedby="defaultRegisterFormPasswordHelpBlock"> </textarea> <label
            for="defaultRegisterFormPassword">Clave</label>
        </div> -->

          <!-- Sign up button -->
          <button
            class="btn btn-institutional my-4 btn-block"
            @click="submitForm($event, 'ruleForm')"
          >
            Enviar
          </button>

          <button class="btn btn-primary my-4 btn-block" @click="retornar()">
            Volver al mapa
          </button>

          <!-- Social register -->
          <p>Social Networks:</p>

          <a
            href="https://www.facebook.com/Geodirsoftware/"
            target="_blank"
            class="mx-2"
            role="button"
            ><i class="fab fa-facebook-f indigo-text"></i
          ></a>

          <a
            href="https://www.youtube.com/channel/UCaZ__ffNRom1j-JD9cpizvQ"
            target="_blank"
            class="mx-2"
            role="button"
            ><i class="fab fa-youtube text-danger"></i
          ></a>

          <a
            href="https://twitter.com/geodirsoftware"
            target="_blank"
            class="mx-2"
            role="button"
            ><i class="fab fa-twitter light-blue-text"></i
          ></a>

          <a
            href="https://www.linkedin.com/company/geodir/?originalSubdomain=ar"
            target="_blank"
            class="mx-2"
            role="button"
            ><i class="fab fa-linkedin-in blue-text"></i
          ></a>

          <hr />
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      context: "oauth2 context",
      code: this.$route.query.code,
      type: this.$route.params.vertical,
      ruleForm: {
        nombre: "",
        apellidos: "",
        empresa: "",
        celular: "",
        email: "",
        mensaje: "",
      },
      rules: {
        email: [
          {
            type: "email",
            required: true,
            message: "Ingrese un correo electrónico válido",
            trigger: "blur",
          },
        ],
        mensaje: [
          {
            required: true,
            message: "Este campo mensaje es obligatorio",
            trigger: "blur",
          },
        ],
        desc: [
          {
            required: true,
            message: "Please input activity form",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    console.log(this.$route);
  },

  methods: {
    retornar() {
      console.log("ingresa aqui");
      this.$router.push("/");
      // location.href = "https://maps.geodir.co/";
      
    },
    submitForm(event, formName) {
      event.preventDefault();
      const url =
        "https://apis.geodir.co/runaban/v1/notificacionInkamaps/sendData";
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "Enviando",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.9)",
          });
          axios
            .post(url, this.ruleForm)
            .then((resp) => {
              // eslint-disable-next-line no-empty
              if (resp.data.status === "OK") {
                console.log(resp);
                loading.close();
                this.$notify({
                  title: "Registro exitoso",
                  message: resp.data.message,
                  type: "success",
                });
                this.$refs[formName].resetFields();
              }
            })
            .catch((error) => {
              loading.close();
              console.log(error);
              this.$notify({
                title: "Registro inválido",
                message: error.data.message,
                type: "error",
              });
            });

          console.log(this.ruleForm);

          // alert('submit!');
        } else {
          this.$notify({
            title: "Warning",
            message: "Complete el formulario !!!",
            type: "warning",
          });
          return false;
        }
      });
    },
    checkForm: function (e) {
      // if (this.name && this.age) {
      //   return true;
      // }

      // this.errors = [];

      // if (!this.name) {
      //   this.errors.push('El nombre es obligatorio.');
      // }
      // if (!this.age) {
      //   this.errors.push('La edad es obligatoria.');
      // }

      e.preventDefault();
      this.$notify({
        title: "Warning",
        message: "Formulario temporalmente inactivo",
        type: "warning",
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style scoped>
/* METODO POR DEFECTO DE BOOTSTRAP MD*/
:root {
  --color-header: #006cd8;
  --color-asociado: #0076ec;
  --color-btn: #006cd8;
  --color-btn-danger: #e20025;
}

body {
  background-color: var(--color-asociado) !important;
  background-image: -webkit-linear-gradient(
    42deg,
    var(--color-asociado) 50%,
    var(--color-header) 50%
  );
}

.btn-institutional {
  background-color: #006cd8 !important;
  border-color: var(--color-btn) !important;
  color: white !important;
}

.form-login-lamsac {
  border-radius: 10px;
  background-color: white;
}

/* FIN METODO POR DEFECTO DE BOOTSTRAP MD*/
.vertical-center {
  min-height: 100%; /* Fallback for browsers do NOT support vh unit */
  min-height: 100vh; /* These two lines are counted as one :-)       */
  display: flex;
  align-items: center;
}

.logo-lamsac {
  width: 30%;
}
.el-form-item {
  margin-bottom: 10px;
}
label {
  display: inline-block;
  margin-bottom: 0 !important;
}
</style>
